import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { motion, useInView } from "framer-motion";
import { MapPin } from "lucide-react";

export function Reveal({ children, className = "", delay = 0, y = 28 }) {
  return (
    <motion.div initial={{ opacity: 0, y }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.25 }}
      transition={{ duration: 0.65, delay, ease: [0.22, 1, 0.36, 1] }} className={className}>
      {children}
    </motion.div>
  );
}

export function CountUp({ to, duration = 1400 }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true });
  const [v, setV] = useState(0);
  useEffect(() => {
    if (!inView) return;
    const start = performance.now();
    const isFloat = !Number.isInteger(to);
    const tick = (t) => {
      const p = Math.min(1, (t - start) / duration);
      const e = 1 - Math.pow(1 - p, 3);
      setV(isFloat ? (to * e).toFixed(1) : Math.round(to * e));
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }, [inView, to, duration]);
  return <span ref={ref} data-testid="countup">{v}</span>;
}

export function Marquee({ items }) {
  const row = [...items, ...items];
  return (
    <div className="marquee overflow-hidden" data-testid="marquee">
      <div className="marquee-track flex gap-3 w-max">
        {row.map((it, i) => (
          <Link key={`${it.label}-${i}`} to={it.to} className="inline-flex items-center gap-1.5 rounded-full border bg-card px-4 py-1.5 text-sm hover:border-primary hover:text-primary transition-colors whitespace-nowrap">
            <MapPin className="h-3.5 w-3.5 text-primary" /> {it.label}
          </Link>
        ))}
      </div>
    </div>
  );
}
